/**
 * Initializes variables used by the product slider/carousel, including:
 * - sliderCells - Array of carousel cell elements
 * - sliderBtns - Array of slider control buttons
 * - Filters for product categories
 *
 * Sets up intersection observers on product cells to detect when they become
 * visible. Updates styling on category filter buttons accordingly.
 *
 * Also initializes click handlers on filters and cells to handle category
 * filtering and selecting cells.
 */
const filtersHero = document.querySelectorAll('[data-name="button-filter-hero"]');
function initVariables() {
  const sliderCells = document.querySelectorAll('[data-name="carousel-cell-product"]');
  const sliderBtns = document.querySelectorAll(".flickity-prev-next-button");

  function checkActiveCategory() {
    let observerOptions = {
      threshold: 1,
    };

    var observer = new IntersectionObserver(observerCallback, observerOptions);

    function observerCallback(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.target.getAttribute("data-filter")) {
          let visibleFilterValue = entry.target.getAttribute("data-filter");
          filtersHero.forEach((el) => {
            if (el.getAttribute("data-filter") == visibleFilterValue) {
              el.firstElementChild.classList.add("active-header");
            } else {
              el.firstElementChild.classList.remove("active-header");
            }
          });
        }
      });
    }

    let target = ".carousel-cell-product";
    document.querySelectorAll(target).forEach((i) => {
      if (i) {
        observer.observe(i);
      }
    });
  }

  sliderBtns.forEach((el) => el.addEventListener("click", checkActiveCategory));
  sliderCells.forEach((el) => el.addEventListener("click", checkActiveCategory));
  sliderCells.forEach((el) => el.addEventListener("touchstart", checkActiveCategory));
  document.addEventListener("keydown", checkActiveCategory);
}

setTimeout(initVariables, 2000);

// Toggle active filter
for (let i = 0; i < filtersHero.length; i++) {
  filtersHero[i].addEventListener("click", changeButton);
}

// Show selected items in slider
function changeButton(e) {
  if (e.target.parentElement.getAttribute("data-filter") == "bestsellers-prod") {
    var flkty = new Flickity(".hp-slider .carousel-slider");
    flkty.selectCell(1, true, false);
  } else if (e.target.parentElement.getAttribute("data-filter") == "new-arrivals-prod") {
    var flkty = new Flickity(".hp-slider .carousel-slider");
    flkty.selectCell(12, true, false);
  }

  const oldActive = document.getElementsByClassName("active-header");
  for (let i = 0; i < oldActive.length; i++) {
    oldActive[i].classList.remove("active-header");
  }
  e.target.classList.add("active-header");
}
